import { parseStoragePath } from "../../shared/volumes/storagePath";
import { VOLUME_NAME_RE } from "../../shared/volumes/types";
import { volumeDownloadPath } from "./apiPaths";

export function resolveStorageFileHref(
  href: string,
  volumeDirPath: (volumeName: string) => string
): string | null {
  let path: string;
  try {
    path = decodeURIComponent(href).replace(/^\p{Cf}+/u, "");
  } catch {
    return null;
  }
  const parsed = parseStoragePath(path);
  if (!parsed || !VOLUME_NAME_RE.test(parsed.volumeName)) return null;
  return volumeDownloadPath(
    volumeDirPath(parsed.volumeName),
    parsed.relativePath
  );
}
